import { IRootState } from '../../../store'
import { IPatientVitals } from '../store/vitals.types'

export const getPatientVitalsSelector = (state: IRootState): IPatientVitals => state.vitals
